export const STATUS_CODE_SUCCESS = 200
export const STATUS_CODE_BAD_REQUEST = 400
export const STATUS_CODE_UNAUTHORIZED = 401
export const STATUS_CODE_FORBIDDEN = 403
